var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"scroll-text"},[_c('div',{ref:"inner",staticClass:"scroll-text__inner",class:{ 'is-scrollable': _vm.scrollable },style:(_vm.innerStyle)},[_c('span',{ref:"content",staticClass:"scroll-text__content"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }